import React from 'react';
import "./DesktopCard.css";

const DesktopCard = ({setActiveVideo, video}) => {
  const {date, image, title, url} = video;
  return <div className="dc-container" onClick={() => setActiveVideo(url)}>
    <img className='dc-thumbnail' alt={title} src={image} />
    <p>{title}</p>
    <p>{date}</p>
  </div>
};

export default DesktopCard;